import { Component, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Location } from '@angular/common';

@Component({
	selector: 'event-type-row',
	template: require('./event-type-row.html')
})
export class EventTypeRowComponent implements OnInit {
	@Input() eventData: any;
	@Input() snFilter: string;
	eventColor: string;
	eventType: string;
	unsubscribe: Subject<void> = new Subject();

	constructor(private location: Location) {}

	ngOnInit() {
		if (this.eventData) {
			this.setEventType(this.eventData);
		}
	}

	isMainShoot = event => event.calendarEventType === 'MAIN_SHOOT';

	isApp = event => {
		if (event.jobId) {
			return event.calendarEventType === 'APPOINTMENT';
		}
	};

	showJob(jobId) {
		this.location.go(`jobs/view/${jobId}`);
	}

	showLead(leadId) {
		this.location.go(`leads/view/${leadId}`);
	}

	private setEventType(event) {
		if (event.calendarEventType === 'MAIN_SHOOT' && event.inLead === false) {
			this.eventColor = 'SHOOT';
			this.eventType = 'MAIN SHOOT';
		} else if (
			event.calendarEventType === 'MAIN_SHOOT' &&
			event.inLead === true
		) {
			this.eventColor = 'LEAD';
			this.eventType = 'MAIN SHOOT';
		} else if (
			event.calendarEventType === 'EXTRA_SHOOT' &&
			event.inLead === false
		) {
			this.eventColor = 'SHOOT';
			this.eventType = 'EXTRA SHOOT';
		} else if (
			event.calendarEventType === 'EXTRA_SHOOT' &&
			event.inLead === true
		) {
			this.eventColor = 'LEAD';
			this.eventType = 'EXTRA SHOOT';
		} else {
			this.eventColor = 'APPOINTMENT';
			this.eventType = 'APPOINTMENT';
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/common/event-type-row/event-type-row.ts